function endOfDay(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(23, 59, 59, 999);
  return d;
}

export function isVacancyActive(content, now = new Date()) {
  if (!content?.vacancyIsActive) return false;
  const expiresAt = endOfDay(content.expiresAt);
  return !expiresAt || expiresAt >= now;
}
